import { useMemo } from "react";
import { Accordion, VoteResult, When } from "../../../components";
import { Votes } from "../../../components/Vote";
import { WhenOptionDetail } from "./WhenOptionDetail";
import { WhenClient, WhenOption, WhenStats } from "../../../../types";

export function WhenTable({ when }: { when: WhenClient }) {
    const { users, options } = when;

    const whenTable = useMemo(() => {
        const table: (WhenOption & WhenStats)[] = Object
            .entries(when.options)
            .map(([title, option]) => {
                const yes = Object.values(option.users).filter(v => v.vote === "yes").length;
                const no = Object.values(option.users).filter(v => v.vote === "no").length;
                const maybe = Object.values(option.users).filter(v => v.vote === "maybe").length;
                return {
                    ...option,
                    title,
                    yes,
                    no,
                    maybe,
                    score: yes + (0.5 * maybe),
                    order: 0,
                };
            })
            .sort((a, b) => b.score - a.score);

        let lastScore = -1;
        for (let i = 0; i < table.length; i++) {
            if (lastScore === table[i].score) {
                table[i].order = table[i - 1].order;
            } else {
                table[i].order = i + 1;
            }
            lastScore = table[i].score;
        }

        return table.sort((a, b) => a.title.localeCompare(b.title));
    }, [when.options, options]);

    const orderLast = Math.max(...whenTable.map(o => o.order));

    return <ul className="poll-options when-options">
        {whenTable.map(option => <li key={option.title} className={`poll-option order-${option.order !== orderLast ? option.order : ""}`}>
            <Accordion title={<VoteResult
                title={<>
                    <div className="votes">
                        <Votes isMaybeOption={when.isMaybeOption} votes={option} />
                    </div>
                    <When date={option.title} />
                </>}
                yes={option.yes}
                no={option.no}
                maybe={option.maybe}
            />} >
                <WhenOptionDetail users={users} option={option} isMaybeOption={when.isMaybeOption} />
            </Accordion>
        </li>)}
    </ul>;
}
